import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-long-vowel-key-wrapper',
  imports: [],
  templateUrl: './rid-long-vowel-key-wrapper.html',
})
export class RidLongVowelKeyWrapper {
  disabled = input<boolean>(false);
}
